import type { Ref } from 'react'

import { Card, WithPopover, type IWithPopoverProps } from '@procurify/ui'

import { ApprovalHistory, type IApprovalHistoryProps } from './ApprovalHistory'

export interface IWithApprovalHistoryPopoverProps
  extends IApprovalHistoryProps, Partial<IWithPopoverProps> {
  ref?: Ref<WithPopover>
}

export const WithApprovalHistoryPopover = ({
  children,
  approvalHistory,
  trigger = 'click',
  placement = 'top',
  ...otherProps
}: IWithApprovalHistoryPopoverProps) => {
  return (
    <WithPopover
      trigger={trigger}
      placement={placement}
      {...otherProps}
      content={
        <Card>
          <Card.Content>
            <ApprovalHistory approvalHistory={approvalHistory} />
          </Card.Content>
        </Card>
      }
    >
      {children}
    </WithPopover>
  )
}
